export default __webpack_public_path__ + "static/media/JUNEDOM2025.04a060ce.png";